import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useHotel } from '../../context/hotel-context';
import { useUser } from '../../context/user-context';
import { today } from '../../helpers/date-helpers';
import { useMeeting } from '../meetings/context/meeting-context';
import Report from './components/report';
import { useReportData } from './context/report-data-context';
import { useIsReport } from './hooks/use-report-location';

const LiveReport = () => {
  const { isReport } = useIsReport();
  const { meetingId } = useParams<{ meetingId?: string }>();
  const { data, loading: dataLoading, refetchRmRecs } = useReportData();
  const { hotel, setBrandCode } = useHotel();
  const { user, oktaUser } = useUser();
  const { loading, meeting, meetingTools, meetingUser, setMeeting, setMeetingId } = useMeeting();

  useEffect(() => {
    refetchRmRecs();
  }, [hotel?.hotel_id]);

  useEffect(() => {
    if (meetingId) {
      setMeetingId(meetingId);
    }
  }, [meetingId]);

  useEffect(() => {
    if (isReport && meeting && meeting.brandCode) {
      setBrandCode(meeting.brandCode);
    }
    if (!isReport && meeting && meeting.meetingDate !== today()) {
      setMeetingId(undefined);
      setMeeting(undefined);
    }
  }, [isReport]);

  return (
    <div>
      {data && (
        <Report
          data={{
            data,
            hotel,
            meetingTools,
            user: meetingUser || user,
            oktaUser,
          }}
          dataLoading={dataLoading}
          meeting={meeting}
          meetingLoading={loading}
          setMeeting={setMeeting}
        />
      )}
    </div>
  );
};

export { LiveReport };

// Report component needs to take out anything that is reliant on
// the context and make sure its just using the meeting and data props
// passed through from the parent component. The parent component is where
// we can use the context to get the meeting and data for a LIVE report,
// and the shared report can get the meeting and data from the URL params
